import React from "react";

import ChevronDownIcon from "@uui/ChevronDown";
import ChevronUpIcon from "@uui/ChevronUp";

import {
  Collapse,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

const Expander = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  const [expanded, setExpanded] = React.useState(false);
  return (
    <Stack
      sx={{
        width: "100%",
        paddingBottom: "14px",
      }}
      direction="column"
    >
      <Divider />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", paddingTop: "14px" }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography
          variant="bodyPrimaryReg"
          sx={{ color: "shades.neutral.600", fontWeight: expanded ? 500 : 400 }}
        >
          {title}
        </Typography>
        <IconButton
          sx={{ color: "black" }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </IconButton>
      </Stack>
      <Collapse in={expanded}>
        <Stack sx={{ width: "100%", padding: "12px 0" }}>{children}</Stack>
      </Collapse>
    </Stack>
  );
};

export default Expander;
